import React from "react"
import { Skeleton } from "antd"

const DeliveryOptionCompactSkeletonCard: React.FC = () => {
  return (
    <div className="mt-3 rounded-lg border p-2 flex flex-row min-w-[260px]">
      <Skeleton.Avatar
        size="small"
        shape="square"
        style={{
          borderRadius: "8px",
          marginRight: "1em",
        }}
      />
      <div className="flex flex-row justify-between w-full">
        <Skeleton.Input
          active
          size="small"
          style={{ minWidth: 75, width: 75, borderRadius: "8px" }}
          className="mr-4"
          block
        />
        <Skeleton.Input active size="small" style={{ borderRadius: "8px" }} block />
      </div>
    </div>
  )
}

export default DeliveryOptionCompactSkeletonCard
